// extracted by mini-css-extract-plugin
export default {"root":"zK4wl","logo":"zdquL"};